import { jwtDecode } from 'jwt-decode';
import { addMinutes } from 'date-fns';

// Lives outside useConfigureAccessToken.tsx so Jest can reach it — that file imports React and
// `config`, and config reads window.config at module load.

// Determine when we need to refetch the token
export function calculateWhenToGetNewToken(accessToken: string, bufferMinutes: number) {
  const decodedToken = jwtDecode(accessToken);
  const expirationTimeInEpoch = decodedToken.exp;
  const expirationTime = !isNaN(Number(decodedToken.exp)) ? new Date(Number(expirationTimeInEpoch) * 1000) : undefined;
  const getNewTokenAt = expirationTime ? addMinutes(expirationTime, -bufferMinutes) : undefined;

  // If we didn't get a token (which shouldn't happen) we can't really determine when to get a new one
  if (!getNewTokenAt) return undefined;

  return getNewTokenAt;
}
